import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
    selector: "love-it-ng-select-all-header",
    templateUrl: "./ng-select-all-header.component.html",
    styleUrls: ["./ng-select-all-header.component.scss"],
    standalone: false
})
export class NgSelectAllHeaderComponent implements OnInit {
  @Input() selectFormControl: FormControl;
  @Input() items: any[];
  @Input() bindValue: string;

  constructor() {}

  ngOnInit(): void {}

  selectAll() {
    const values = this.items.map((value) => value[this.bindValue]);
    this.selectFormControl.setValue(values);
    this.selectFormControl.markAsDirty();
  }
}
